


















































import Vue from 'vue'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { TranslateResult } from 'vue-i18n'
import { KeyActionEnum, SnackbarStateEnum } from '@/types/enums'
import { GridOptions } from '@/types'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { hexToRgba } from '@/services/hex-to-rgba'
import {
  DELETE_COMMISSION_NOTE,
  FETCH_COMMISSION_NOTES,
  FETCH_COMMISSION_NOTES_METADATA
} from '@/store/action-types'
import moment from 'moment'
import PrivateCellRenderer from '@/components/cell-renderer/PrivateCellRenderer.vue'
import { KommissionNotesMetaDataResponse, KommissionNotesResponse, ResponseBase } from '@/types/service-response'
import { CommissionNoteType } from '@/model/commissions/CommissionNoteType'
import { CommissionNote } from '@/model/commissions/CommissionNote'
import { CommissionNoteEmployee } from '@/model/commissions/CommissionNoteEmployee'
import CommissionNotesDialog from '@/components/master-data/commissions/CommissionNotesDialog.vue'
import { Commission } from '@/model/commissions/Commission'
import { keyActionService } from '@/services/key-action-service'
import { KeyAction } from '@/model/KeyAction'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  employeeList: CommissionNoteEmployee[]
  noteTypeList: CommissionNoteType[]

  gridData: CommissionNote[]
  gridOptions: GridOptions
  gridFrameworkComponents: Object
  overlayNoRowsTemplate: string
  currentSelectedRowId: string
  currentSelectedRowData: CommissionNote | undefined
  showDialog: boolean
  showDeleteDialog: boolean

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'CommissionNotes',

  components: {
    AgGridVue,
    DeleteDialog,
    CommissionNotesDialog
  },

  props: {
    commissionId: Number,
    commission: Object as () => Commission
  },

  data (): ComponentData {
    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      employeeList: [],
      noteTypeList: [],

      gridData: [],
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('masterData.addresses.title'), field: 'noteTitle' },
          { headerName: this.$t('masterData.addresses.responsibleName'),
            valueGetter: (params: any) => {
              //@ts-ignore
              const employee: CommissionNoteEmployee | undefined = this.employeeList.find((item: CommissionNoteEmployee) => item.id === params.data.responsibleEmployee)
              return employee ? employee.fullName : ''
            }
          },
          { headerName: this.$t('masterData.addresses.noticeTypeDescription'),
            valueGetter: (params: any) => {
              //@ts-ignore
              const noteType: CommissionNoteType | undefined = this.noteTypeList.find((item: CommissionNoteType) => item.id === params.data.noteType)
              return noteType ? noteType.name : ''
            }
          },
          { headerName: this.$t('masterData.addresses.start'),
            valueGetter: (params: any) => {
              return params.data.dateStartIso ? moment(params.data.dateStartIso, "YYYY-MM-DD HH:mm:ss").format("DD.MM.YYYY") : ''
            }
          },
          { headerName: this.$t('masterData.addresses.due'),
            valueGetter: (params: any) => {
              return params.data.dateEndIso ? moment(params.data.dateEndIso, "YYYY-MM-DD HH:mm:ss").format("DD.MM.YYYY") : ''
            }
          },
          { headerName: this.$t('masterData.addresses.completed'), field: 'alreadyDone' },
          { headerName: this.$t('masterData.addresses.private'), field: 'isPrivate', cellRenderer: 'privateRenderer'},
          { headerName: this.$t('masterData.addresses.description'), field: 'noteText' }
        ]
      },
      gridFrameworkComponents: {
        privateRenderer: PrivateCellRenderer
      },
      overlayNoRowsTemplate: '<span>' + this.$t('errors.noRowsToShow') + '</span>',
      currentSelectedRowId: '',
      currentSelectedRowData: undefined,
      showDialog: false,
      showDeleteDialog: false,

      keyActions: []
    }
  },

  watch: {
    commissionId (newVal: number): void {
      if(newVal && newVal !== 0) {
        this.currentSelectedRowId = ''
        this.currentSelectedRowData = undefined
        this.fetchNotesData()
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isEnableButtons (): boolean {
      return !!(this.currentSelectedRowData && this.currentSelectedRowData.id)
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },
  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | null): boolean {
      if(action instanceof Create) {
        return true
      } else if(action instanceof Edit) {
        return this.isEnableButtons
      } else if(action instanceof Delete) {
        return this.isEnableButtons
      } else {
        return false
      }
    },

    onRowClicked (params: any): void {
      this.currentSelectedRowId = params.node.data.id
      this.currentSelectedRowData = this.gridData.find((item: CommissionNote) => item.id === parseInt(this.currentSelectedRowId))
    },

    onAddNoteClick ():void {
      this.create()
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.currentSelectedRowData = undefined
      this.showDialog = true
    },

    onEditNoteButtonClick ():void {
      this.update()
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.showDialog = true
    },

    dialogSaved (): void {
      this.fetchNotesData()
      this.showDialog = false
    },

    closeDialog (): void {
      this.showDialog = false
    },

    onDeleteNoteButtonClick ():void {
      this.delete()
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.showDeleteDialog = true
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
        if(this.currentSelectedRowData && this.currentSelectedRowData.id) {
          this.deleteNote(this.currentSelectedRowData.id)
        }
    },

    async deleteNote (payload: number): Promise<void> {
      try {
        let response: ResponseBase = await this.$store.dispatch(DELETE_COMMISSION_NOTE, payload)
        if(!response.IsError) {
          this.onDeleteDialogClose()
          this.currentSelectedRowId = ''
          this.currentSelectedRowData = undefined
          this.messageSnackbar = response.Result ? response.Result : this.$t('success.dataHaveBeenDeleted')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.fetchNotesData()
        } else {
          this.onDeleteDialogClose()
          this.currentSelectedRowId = ''
          this.currentSelectedRowData = undefined
          this.messageSnackbar = response.Result ? response.Result : this.$t('errors.dataCouldNotBeDeleted')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeDeleted')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchNotesData (): Promise<void> {
      try {
        const response: KommissionNotesResponse = await this.$store.dispatch(FETCH_COMMISSION_NOTES, this.commissionId)
        if(response && !response.IsError && response.Data) {
          this.gridData = CommissionNote.createFromResponse(response.Data)
        } else {
          this.messageSnackbar =  response.Result ? response.Result : this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchNoteMetaData (): Promise<void> {
      try {
      const response: KommissionNotesMetaDataResponse = await this.$store.dispatch(FETCH_COMMISSION_NOTES_METADATA)
        if(response && !response.IsError && response.Data) {
          this.employeeList = CommissionNoteEmployee.createFromResponse(response.Data.Mitarbeiter)
          this.noteTypeList = CommissionNoteType.createFromResponse(response.Data.NotizArten)
        } else {
          this.messageSnackbar =  response.Result ? response.Result : this.$t('errors.dataCouldNotBeRead')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },
  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null),
    ]
  },

  mounted () {
    window.addEventListener('keydown', this.onKeydown)
    this.fetchNoteMetaData()
    this.fetchNotesData()
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
